enum FileFormats {
    PDF = 'pdf',
    ZPL = 'zpl',
}

export default FileFormats